import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Avatar, Row, Col, Icon, Badge } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import flattenDeep from 'lodash/flattenDeep';
import DataSet from '@antv/data-set';
import moment from 'moment';

import './index.scss';

import { APP_PAGES, ROUTE_PATH } from '../../../../../data/config/constants';
import { showMessage, getProcessedSelectedFilters } from '../../../../../data/config/utils';
import { IMG_ERROR, IMG_CHAT_INTERFACE, IMG_EMPTY, IMG_CHATTING, IMG_PERSON } from '../../../../../data/assets/img';
import { pageChanged } from '../../../../../data/redux/page_details/actions';
import { getAllIntents } from '../../../../../data/redux/nlp_details/actions';
import * as usersActions from '../../../../../data/redux/users_details/actions';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardContainer from '../../../components/cardcontainer';
import ChartStatusCard from '../../../components/chartstatuscard';
import CustomHeader from '../../../../../components/customheader';
import Graph from '../../../components/charts/graph';
import ShowMessage from '../../../../../components/showmessage';
import SpinnerLoader from '../../../../../components/spinnerloader';
import ConversationItemLoader from '../../../components/conversationitem/loaders';
import ConversationItem from '../../../components/conversationitem';
import ProfileAvatar from '../../../../../components/profileavatar';
import ChatBody from '../../../components/chatinterface/components/chatbody';
import ProfileCard from '../../../components/profilecard';
import ErrorBoundary from '../../../../../components/errorboundary';
import CloseTag from '../../../../../components/closetag';
import Filters from '../../../components/filters';

const datePickerFilterOptions = [
  { name: "Today", value: "today" },
  { name: "Yesterday", value: "yesterday" },
  { name: "Last 7 days", value: "last_7_days" },
  { name: "Last 15 days", value: "last_15_days" },
  { name: "Last 30 days", value: "last_30_days" },
  { name: "This Month", value: "this_month" },
  { name: "Last Month", value: "last_month" },
  { name: "Custom Range", value: "custom_range" }
];

class UserProfile extends PureComponent {
  constructor() {
    super();
    this.chatContainer = null;
    this.chatlogListheaderContainer = null;
    this.state = {
      date_range_props: {},
      chatlog_filter_visibility: {
        visible: false,
        animation: 'ori-translate-down',
      },
    };
  }

  componentDidMount() {
    const { actions, match, history } = this.props;
    const { user_profile } = this.props.users_details;
    actions.pageChanged(APP_PAGES.USERS, APP_PAGES.USERS);
    actions.getAllIntents();
    if (match && match.params && match.params.userId && match.params.userIdType) {
      if (user_profile.chatlog_list_filters.length === 0) {
        actions.getChatlogListFilters();
      }
      const payload = { userId: match.params.userId, idType: match.params.userIdType };
      const filters = {
        startDate: user_profile.filters.date_range[0],
        endDate: user_profile.filters.date_range[1],
        platform: user_profile.filters.platform,
      };
      actions.getUserBasicInfo(payload);
      actions.getUserStats({ ...payload, ...filters });
      actions.getUserEventHistogram({ ...payload, ...filters });
      actions.getUserChatlogList({ ...payload, filters, skip: 0, required: user_profile.chatlog_list_pagination.required });
    } else {
      history.goBack();
      showMessage('error', 'user data is missing');
    }
  }

  componentWillUpdate() {
    if (this.chatlogListheaderContainer) {
      this.chatlogListHeaderContainerHeight = this.chatlogListheaderContainer.offsetHeight;
    }
  }

  goToUsersPage = () => {
    const { history } = this.props;
    history.push(ROUTE_PATH.USERS);
  };

  setChatlogListHeaderContainerRef = el => { this.chatlogListheaderContainer = el; };

  setChatContainerRef = el => { this.chatContainer = el; };

  handlePlatformChange = event => {
    const { match, history, actions } = this.props;
    const { user_profile } = this.props.users_details;
    if (match && match.params && match.params.userId && match.params.userIdType) {
      const platform = event.target.value;
      const payload = { userId: match.params.userId, idType: match.params.userIdType };
      const processed_filters = getProcessedSelectedFilters(user_profile.chatlog_list_selected_filters);
      const filters = {
        startDate: user_profile.filters.date_range[0],
        endDate: user_profile.filters.date_range[1],
        platform,
      };
      actions.getUserStats({ ...payload, ...filters }, () => actions.updateUsersState(platform, "user_profile.filters.platform"));
      actions.getUserEventHistogram({ ...payload, ...filters });
      const chatlog_list_payload = {
        ...payload,
        filters: {
          ...processed_filters,
          ...filters,
        },
        skip: 0,
        required: user_profile.chatlog_list_pagination.required
      };
      actions.getUserChatlogList(chatlog_list_payload);
    } else {
      history.goBack();
      showMessage('error', 'user data is missing');
    }
  };

  closeCalender = () => {
    this.setState({
      date_range_props: {}
    });
  };

  onChangeDateRangeFilter = type => {
    const { user_profile } = this.props.users_details;
    let date_range = user_profile.filters.date_range;
    switch (type) {
      case "today":
        date_range = [moment(new Date(), "DD-MM-YYYY"), moment(new Date(), "DD-MM-YYYY")];
        break;
      case "yesterday":
        date_range = [moment(new Date(), "DD-MM-YYYY").subtract(1, "days"), moment(new Date(), "DD-MM-YYYY").subtract(1, "days")];
        break;
      case "last_7_days":
        date_range = [moment(new Date(), "DD-MM-YYYY").subtract(6, "days"), moment(new Date(), "DD-MM-YYYY")];
        break;
      case "last_15_days":
        date_range = [moment(new Date(), "DD-MM-YYYY").subtract(14, "days"), moment(new Date(), "DD-MM-YYYY")];
        break;
      case "last_30_days":
        date_range = [moment(new Date(), "DD-MM-YYYY").subtract(29, "days"), moment(new Date(), "DD-MM-YYYY")];
        break;
      case "this_month":
        date_range = [moment().startOf('month'), moment(new Date(), "DD-MM-YYYY")];
        break;
      case "last_month":
        date_range = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
        break;
      case "custom_range":
        this.setState({ date_range_props: { open: true } });
        break;
    }
    if (type !== "custom_range") {
      this.handleDateRangeChange(date_range, type);
    }
  };

  handleDateRangeChange = (date_range, type) => {
    const { match, history, actions } = this.props;
    const { user_profile } = this.props.users_details;
    const { date_range_props } = this.state;
    if (date_range_props && date_range_props.open) {
      this.setState({ date_range_props: { open: false } }, () => this.setState({ date_range_props: {} }));
    }
    if (match && match.params && match.params.userId && match.params.userIdType) {
      const payload = { userId: match.params.userId, idType: match.params.userIdType };
      const processed_filters = getProcessedSelectedFilters(user_profile.chatlog_list_selected_filters);
      const filters = {
        startDate: date_range[0],
        endDate: date_range[1],
        platform: user_profile.filters.platform,
      };
      actions.getUserStats({ ...payload, ...filters }, () => {
        actions.updateUsersState(date_range, "user_profile.filters.date_range");
        actions.updateUsersState(typeof (type) === "string" ? type : "custom_range", "user_profile.filters.date_range_type")
      });
      actions.getUserEventHistogram({ ...payload, ...filters });
      const chatlog_list_payload = {
        ...payload,
        filters: {
          ...processed_filters,
          ...filters,
        },
        skip: 0,
        required: user_profile.chatlog_list_pagination.required
      };
      actions.getUserChatlogList(chatlog_list_payload);
    } else {
      history.goBack();
      showMessage('error', 'user data is missing');
    }
  };

  showFilterLayout = () => {
    this.setState({
      chatlog_filter_visibility: {
        ...this.state.chatlog_filter_visibility,
        visible: true,
        animation: 'ori-translate-down'
      }
    });
  };

  hideFilterLayout = () => {
    this.setState({
      chatlog_filter_visibility: {
        ...this.state.chatlog_filter_visibility,
        animation: 'ori-fade-out-up',
      }
    }, () => {
      setTimeout(() => {
        this.setState({
          chatlog_filter_visibility: {
            ...this.state.chatlog_filter_visibility,
            visible: false
          }
        });
      }, 400)
    });
  };

  handleChatlogFilterUpdate = (key, value) => {
    this.props.actions.updateUsersState(value, `user_profile.chatlog_list_selected_filters.${key}`);
  };

  onCloseChatlogFilterTag = tag => {
    const { actions, match } = this.props;
    const { user_profile } = this.props.users_details;
    const { chatlog_filter_visibility } = this.state
    if (tag.filterKey && tag.id) {
      const filterValue = user_profile.chatlog_list_selected_filters[tag.filterKey].filter(item => item.id !== tag.id);
      this.props.actions.updateUsersState(filterValue, `user_profile.chatlog_list_selected_filters.${tag.filterKey}`);
      if (!chatlog_filter_visibility.visible && match && match.params && match.params.userId && match.params.userIdType) {
        let processed_filters = getProcessedSelectedFilters(filterValue);
        const payload = {
          userId: match.params.userId,
          idType: match.params.userIdType,
          skip: 0,
          required: user_profile.chatlog_list_pagination.required,
          filters: {
            ...processed_filters,
            startDate: user_profile.filters.date_range[0],
            endDate: user_profile.filters.date_range[1],
            platform: user_profile.filters.platform,
          }
        };
        actions.getUserChatlogList(payload);
      }
    } else {
      showMessage('error', 'chatlog filter data is corrupted');
    }
  };


  clearChatlogFilter = () => {
    this.props.actions.updateUsersState({}, "user_profile.chatlog_list_selected_filters");
  };

  applyChatlogFilter = () => {
    const { actions, match } = this.props;
    const { user_profile } = this.props.users_details;
    if (match && match.params && match.params.userId && match.params.userIdType) {
      let processed_filters = getProcessedSelectedFilters(user_profile.chatlog_list_selected_filters);
        const payload = {
          userId: match.params.userId,
          idType: match.params.userIdType,
          skip: 0,
          required: user_profile.chatlog_list_pagination.required,
          filters: {
            ...processed_filters,
            startDate: user_profile.filters.date_range[0],
            endDate: user_profile.filters.date_range[1],
            platform: user_profile.filters.platform,
          }
        };
        actions.getUserChatlogList(payload);
    }
    this.hideFilterLayout();
  };

  loadMoreUserChatlogList = () => {
    const { actions, match } = this.props;
    const { user_profile } = this.props.users_details;
    if (match && match.params && match.params.userId && match.params.userIdType) {
      let processed_filters = getProcessedSelectedFilters(user_profile.chatlog_list_selected_filters);
      const payload = {
        userId: match.params.userId,
        idType: match.params.userIdType,
        skip: user_profile.chatlog_list.length,
        required: user_profile.chatlog_list_pagination.required,
        filters: {
          ...processed_filters,
          startDate: user_profile.filters.date_range[0],
          endDate: user_profile.filters.date_range[1],
          platform: user_profile.filters.platform,
        }
      };
      actions.getUserChatlogList(payload);
    }
  }


  showChatlogInterface = chatlog_item => {
    const { actions } = this.props;
    const { active_chatlog_details } = this.props.users_details.user_profile;
    if (chatlog_item && chatlog_item.sessionId) {
      if (active_chatlog_details.chatlog_item && active_chatlog_details.chatlog_item.sessionId && active_chatlog_details.chatlog_item.sessionId === chatlog_item.sessionId) {
        showMessage('warning', 'chatlog details for this chat item is already active.')
      } else {
        actions.getActiveChatlogDetails(chatlog_item);
      }
    } else {
      showMessage('error', 'sessionId is missing in chatlog item.')
    }
  };

  closeChatlogInterface = () => {
    const active_chatlog_details = {
      visible: false,
      chatlog_item: null,
      messages: [],
      chat_profile: {}
    };
    this.props.actions.updateUsersState(active_chatlog_details, "user_profile.active_chatlog_details");
  };

  renderCustomHeader = () => {
    const { user_profile, loaders } = this.props.users_details;
    const { date_range_props } = this.state;
    const channels = user_profile.basic_info.channels && user_profile.basic_info.channels.length > 0 ? [{ value: 'all', name: 'All' }, ...user_profile.basic_info.channels] : [{ value: 'all', name: 'All' }];
    return (
      <CustomHeader
        granularity_options={channels}
        granularity_value={user_profile.filters.platform}
        granularity_disabled={loaders.stats_loading}
        onChangeGranularity={this.handlePlatformChange}
        date_range={user_profile.filters.date_range}
        date_range_props={date_range_props}
        date_range_disabled={loaders.stats_loading}
        onChangeDateRange={this.handleDateRangeChange}
        first_button_class="ori-font-xs ori-lr-pad-15"
        first_button_type="primary"
        first_button_text="See all users"
        onClickFirstButton={this.goToUsersPage}
        second_button_class="ori-font-xs ori-lr-pad-15 ori-btn-fill-danger"
        second_button_text="Back"
        onClickSecondButton={this.props.history.goBack}
        dropdown_options={datePickerFilterOptions}
        dropdown_value={user_profile.filters.date_range_type}
        dropdown_disabled={loaders.stats_loading}
        onChangeDropdown={this.onChangeDateRangeFilter}
        show_granularity
        show_date_range
        show_dropdown
        show_first_button
        show_second_button
      />
    );
  };

  renderUserStatsCard = () => {
    const { user_profile, loaders } = this.props.users_details;
    if (user_profile.stats.length !== 0) {
      return (
        <div className="ori-flex ori-flex-wrap ori-t-pad-10 ori-b-pad-5 ori-lr-mrgn-neg-10">
          {
            user_profile.stats.map((item, index) => {
              return (
                <ErrorBoundary key={index}>
                  <div className="ori-stats-card-width ori-pad-10">
                    <ChartStatusCard card_data={item} value_key='count' loading={loaders.stats_loading} />
                  </div>
                </ErrorBoundary>
              );
            })
          }
        </div>
      );
    }
  };

  renderUserEventHistogram = () => {
    const { user_profile, loaders } = this.props.users_details;
    const custom_header_props = {
      title: "Event Histogram",
    };
    let histogram_dv = user_profile.event_histogram;
    if (user_profile.event_histogram.length > 0) {
      const fields = Object.keys(user_profile.event_histogram[0]).filter(key => key !== "name");
      const ds = new DataSet();
      histogram_dv = ds.createView().source(user_profile.event_histogram);
      histogram_dv.transform({
        type: "fold",
        key: "date",
        value: "count",
        fields,
      });
    }
    return (
      <ErrorBoundary>
        <CardContainer custom_header_props={custom_header_props} emtpy_condition={user_profile.event_histogram.length === 0} load_error={loaders.event_histogram_load_error} loading={loaders.event_histogram_loading} show_custom_header>
          <Graph type="intervalStack" data={histogram_dv} x_axis="date" y_axis="count" color_key={"name"} shape="smooth" height={340} padding={[40, 25, 60, 60]} legend />
        </CardContainer>
      </ErrorBoundary>
    );
  };

  renderChatHistoryCards = () => {
    const { user_profile, loaders } = this.props.users_details;
    if (user_profile.chatlog_list.length === 0 && !loaders.chatlog_list_loading) {
      return (
        <ShowMessage img_src={IMG_EMPTY} title="Empty" message="chat history data is not avaliable for this filters." height={120} width={120} />
      );
    }
    return (
      <InfiniteScroll
        scrollableTarget="userChatHistoryCardsContainer"
        dataLength={user_profile.chatlog_list.length}
        hasMore={user_profile.chatlog_list_pagination.load_more}
        scrollThreshold={0.9}
        loader={<ConversationItemLoader />}
        next={this.loadMoreUserChatlogList}
      >
        {
          user_profile.chatlog_list.map(item => {
            return (
              <ErrorBoundary key={item.sessionId}>
                <ConversationItem
                  chat_item={item}
                  active={user_profile.active_chatlog_details.chatlog_item && user_profile.active_chatlog_details.chatlog_item.sessionId === item.sessionId}
                  handleChatItemClicked={this.showChatlogInterface}
                  hide_avatar
                />
              </ErrorBoundary>
            );
          })
        }
      </InfiniteScroll>
    );
  };

  renderChatlogInterface = () => {
    const { screen_height, screen_width } = this.props;
    const { user_profile, loaders } = this.props.users_details;
    const tablet = screen_width >= 768 && screen_width <= 1024;
    const mobile = screen_width < 768;

    if (loaders.active_chatlog_details_load_error) {
      return (
        <Col
          xs={24}
          md={tablet ? 15 : 18}
          style={{
            height: `${screen_height - 100}px`,
            maxHeight: "768px"
          }}
        >
          <ShowMessage
            img_src={IMG_ERROR}
            title="Error"
            message="Unable to load chatlog details. Something went wrong."
            height={180}
            width={180}
          />
        </Col>
      );
    }
    if (user_profile.active_chatlog_details.visible) {
      return (
        <Fragment>
          <Col xs={24} md={tablet ? 15 : 12} style={{ backgroundImage: `url(${IMG_CHAT_INTERFACE})` }}>
            <div className="ori-relative ori-bg-white ori-b-border-light ori-r-border-light">
              <div className="ori-flex-column ori-flex-jc" style={{ height: '60px' }}>
                <ProfileAvatar avatar_bg_class={{ "ori-bg-primary": true }} container_class="ori-lr-pad-15" title={user_profile.basic_info.name} timestamp={user_profile.active_chatlog_details.chatlog_item ? user_profile.active_chatlog_details.chatlog_item.lastMessageTimeStamp : ""} />
              </div>
              <div className="ori-absolute ori-align-top-7 ori-align-right-5 ori-pad-10 ori-font-md ori-font-light-hover-default" onClick={this.closeChatlogInterface}>
                <Icon type="close" />
              </div>
            </div>
            <div className="ori-overflow-x-hidden ori-overflow-y-auto" style={{ height: `${screen_height - 60 - 100}px`, maxHeight: `${768 - 60}px` }} ref={this.setChatContainerRef}>
              <ChatBody
                active_chat_item={user_profile.active_chatlog_details.chatlog_item}
                chatContainer={this.chatContainer}
                messages={user_profile.active_chatlog_details.messages}
              />
            </div>
          </Col>
          <Col xs={24} md={6} className={classNames("ori-overflow-x-hidden ori-overflow-y-auto", { "ori-display-none": mobile || tablet })} style={{ height: `${screen_height - 100}px`, maxHeight: "768px" }}>
            {
              isEmpty(user_profile.active_chatlog_details.chat_profile) ?
                <ShowMessage img_src={IMG_PERSON} message="Chat profile details are not avaliable" height={100} width={50} color='primary' /> :
                <ErrorBoundary>
                  <ProfileCard profile_details={user_profile.active_chatlog_details.chat_profile} />
                </ErrorBoundary>
            }
          </Col>
        </Fragment>
      );
    }
    return (
      <Col xs={24} md={tablet ? 15 : 18} style={{ height: `${screen_height - 100}px`, maxHeight: "768px" }}>
        <ShowMessage img_src={IMG_CHATTING} title="Chatlog details" message="Please click on chat history item to see chatlog details." height={180} width={180} />
      </Col>
    );
  }

  render() {
    const { screen_width, screen_height } = this.props;
    const { loaders, user_profile } = this.props.users_details;
    const { chatlog_filter_visibility, date_range_props } = this.state;

    if (loaders.user_info_loading && !loaders.user_info_loaded) {
      return (
        <div className="ori-pad-20">
          <div className="ori-tb-pad-5 ori-flex-row">
            <div className="ori-border-radius-half ori-card-loading" style={{ height: '110px', width: '110px' }} />
            <div className="ori-l-pad-25 ori-full-flex">
              <div className="ori-b-border-default ori-tb-pad-10">
                <p className="ori-height-xxl ori-card-loading" style={{ width: '120px' }} />
              </div>
              <PageHeaderLoader />
            </div>
          </div>
          <div className="ori-flex-row ori-flex-wrap">
            {
              [1, 2, 3].map(i => {
                return (
                  <div className="ori-card-loading ori-r-mrgn-20 ori-tb-mrgn-10 ori-border-radius-20" style={{ height: '100px', width: '250px' }} key={i} />
                );
              })
            }
          </div>
          <div className="ori-card-loading ori-border-radius-4 ori-tb-mrgn-10" style={{ height: '410px' }} />
        </div>
      );
    } else if (!loaders.user_info_loading && loaders.user_info_loaded) {
      const chatlog_list_header_container_height = this.chatlogListHeaderContainerHeight ? this.chatlogListHeaderContainerHeight : 60;

      const tablet = screen_width >= 768 && screen_width <= 1024;
      const is_chatlog_list_selected_filters_empty = isEmpty(user_profile.chatlog_list_selected_filters) ? true : flattenDeep(Object.values(user_profile.chatlog_list_selected_filters)).length === 0;
      return (
        <div className="ori-relative ori-pad-20 oriUserProfileContainer">
          {
            date_range_props && date_range_props.open &&
            <div className="ori-absolute ori-align-full ori-zindex-1" onClick={this.closeCalender} />
          }
          <div className="ori-t-pad-5 ori-b-pad-15 ori-flex-row">
            <div className="ori-r-pad-25">
              <Avatar size={110} src={user_profile.basic_info.imgUrl} icon="user" alt="U" />
            </div>
            <div className="ori-full-flex">
              <div className="ori-b-border-default ori-tb-pad-5">
                <span className="ori-font-bold ori-font-xxl ori-font-primary ori-r-mrgn-30 ori-capitalize">{user_profile.basic_info.customer_name}</span>
                {
                  [1, 2, 3].map(i => {
                    if (user_profile.basic_info[`udf${i}`]) {
                      return (
                        <span key={i} className="ori-font-xs ori-font-black ori-font-bold ori-lr-mrgn-15">. &nbsp;{user_profile.basic_info[`udf${i}`]}</span>
                      );
                    }
                  })
                }
              </div>
              {this.renderCustomHeader()}
            </div>
          </div>
          {this.renderUserStatsCard()}
          {this.renderUserEventHistogram()}
          <Row className="ori-relative ori-t-mrgn-20 ori-border-radius-4 ori-box-shadow-light ori-bg-white userChatHistoryContainer">
            {
              loaders.active_chatlog_details_loading &&
              <div className="ori-absolute ori-align-full ori-zindex-1 ori-flex-row ori-flex-jc ori-flex-ac ori-bg-white ori-opacity-medium">
                <SpinnerLoader size="large" text="loading" />
              </div>
            }
            <Col xs={24} md={tablet ? 9 : 6} className="ori-relative ori-overflow-hidden ori-r-border-light">
              {
                loaders.chatlog_list_loading &&
                <div className="ori-absolute ori-align-full ori-zindex-1 ori-flex-row ori-flex-jc ori-flex-ac ori-bg-white ori-opacity-medium">
                  <SpinnerLoader size="large" text="loading" />
                </div>
              }
              <div className="ori-relative ori-l-pad-10 ori-t-pad-10 ori-r-pad-30 ori-b-border-light" style={{ minHeight: '60px' }} ref={this.setChatlogListHeaderContainerRef}>
                {
                  !chatlog_filter_visibility.visible && is_chatlog_list_selected_filters_empty &&
                  <p className="ori-animated ori-fade-in ori-absolute ori-font-md alignTitle">Chat History</p>
                }
                {
                  !chatlog_filter_visibility.visible && user_profile.chatlog_list_filters.length > 0 &&
                  <div className="ori-absolute ori-animated ori-fade-in ori-cursor-ptr ori-lr-pad-5 ori-font-light ori-flex-column ori-font-light-hover-default alignIcon" onClick={this.showFilterLayout}>
                    <Badge className="ori-flex-row ori-flex-jc filterBadge" count={user_profile.chatlog_list_pagination.total - user_profile.chatlog_list.length} overflowCount={9999}>
                      <Icon type="filter" className="ori-font-18" />
                    </Badge>
                    <p className="ori-font-xxs">FILTER</p>
                  </div>
                }
                {
                  chatlog_filter_visibility.visible &&
                  <div className="ori-absolute ori-animated ori-fade-in ori-cursor-ptr ori-flex ori-lr-pad-10 ori-tb-pad-5 ori-font-light ori-font-md alignIcon" onClick={this.hideFilterLayout}>
                    <Icon type="close" className="ori-font-md" />
                  </div>
                }
                {
                  !is_chatlog_list_selected_filters_empty &&
                  <div className="ori-lr-pad-5 ori-flex-row ori-flex-wrap closeTagContainer">
                    {

                      flattenDeep(Object.values(user_profile.chatlog_list_selected_filters)).map((item, index) => {
                        return (
                          <div key={index} className="ori-animated ori-fade-in ori-b-mrgn-5 ori-r-mrgn-5">
                            <CloseTag
                              container_class="ori-bg-primary ori-font-white ori-border-radius-4 ori-border-primary"
                              tag_item={item}
                              handleTagClose={this.onCloseChatlogFilterTag}
                              label={item.label}
                            />
                          </div>
                        );
                      })
                    }
                  </div>
                }
                {
                  chatlog_filter_visibility.visible &&
                  <div className={`ori-absolute ori-animated ori-align-left ori-align-right ori-zindex-100 ori-bg-white ori-t-border-light ori-b-border-light ${chatlog_filter_visibility.animation}`} style={{ top: '100%' }}>
                    <Filters
                      container_height={screen_height - chatlog_list_header_container_height - 100}
                      filters={user_profile.chatlog_list_filters}
                      selected_filters={user_profile.chatlog_list_selected_filters}
                      handleFilterUpdate={this.handleChatlogFilterUpdate}
                      handleFilterTagClose={this.onCloseChatlogFilterTag}
                      handleClearFilter={this.clearChatlogFilter}
                      handleApplyFilter={this.applyChatlogFilter}
                    />
                  </div>
                }
              </div>
              <div
                id="userChatHistoryCardsContainer"
                className="ori-relative ori-overflow-x-hidden ori-overflow-y-auto userChatHistoryCardsContainer"
                style={{
                  height: `${screen_height - chatlog_list_header_container_height - 100}px`,
                  maxHeight: "calc(768px - 60px)"
                }}
              >
                {this.renderChatHistoryCards()}
              </div>
            </Col>
            {this.renderChatlogInterface()}
          </Row>
        </div>
      );
    } else if (!loaders.user_info_loading && !loaders.user_info_loaded) {
      return (
        <ShowMessage
          img_src={IMG_ERROR}
          title="Error"
          message="unable to load user profile. please check your internet connection and reload the page."
          height={150}
          width={150}
          button_type="primary"
          handleButtonClick={this.goToUsersPage}
          show_button
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    screen_height: state.page_details.device_data.screen_height,
    allowedChannels: state.admin_details.allowedChannels,
    users_details: state.users_details,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged, getAllIntents }, usersActions), dispatch),
  };
};

UserProfile.propTypes = {
  users_details: PropTypes.object,
  screen_width: PropTypes.number,
  screen_height: PropTypes.number,
  allowedChannels: PropTypes.array,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(UserProfile);


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/users/userprofile/index.js